import type { ComponentProps } from "react"
import type { OrderNote } from "@/api/account-order-detail"
import { cn } from "@/utilities"

function formatNoteDate(value: string): string {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value || "-"
  }

  return new Intl.DateTimeFormat("pt-BR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date)
}

interface OrderUpdatesProps extends ComponentProps<"div"> {
  notes: OrderNote[]
}

export function OrderUpdates({
  notes,
  className,
  ...props
}: OrderUpdatesProps) {
  if (notes.length === 0) {
    return null
  }

  return (
    <div className={cn("space-y-4", className)} {...props}>
      <h2 className='font-semibold text-foreground text-xl'>
        Atualizações do pedido
      </h2>
      <ol className='space-y-3'>
        {notes.map((note) => (
          <li
            className='rounded-lg border border-border bg-muted/50 p-4'
            key={note.id}
          >
            <p className='mb-2 text-muted-foreground text-xs'>
              {formatNoteDate(note.date)}
            </p>
            <div
              className='text-foreground text-sm leading-relaxed'
              dangerouslySetInnerHTML={{ __html: note.content }}
            />
          </li>
        ))}
      </ol>
    </div>
  )
}
